/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Home_DescriptionInputs */

const en_brand_home_description = /** @type {(inputs: Brand_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with an idea, continue an existing codebase, or find direction with your team. Choose your starting point below.`)
};

const id_brand_home_description = /** @type {(inputs: Brand_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari ide, lanjutkan kode yang ada, atau susun arah bersama tim. Pilih langkah awalmu di bawah.`)
};

/**
* | output |
* | --- |
* | "Start with an idea, continue an existing codebase, or find direction with your team. Choose your starting point below." |
*
* @param {Brand_Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const brand_home_description = /** @type {((inputs?: Brand_Home_DescriptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Home_DescriptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brand_home_description(inputs)
	return en_brand_home_description(inputs)
});